import React from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

const TextButton = ({ onClick, children, className, ...props }) => (
    <button type="button" onClick={onClick} {...props} className={cn(styles.button, className)}>
        {children}
    </button>
);

export default TextButton;
